export default "__VITE_ASSET__895c248e__"